import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, managementHomeRoute } from 'config/Api.Config';
import { isMobile } from 'react-device-detect';
import useProviderStatementBalanceEmailTemplate, {
  ProviderStatementBalanceEmailTemplateAction,
} from './ProviderStatementBalanceEmailTemplate.Hooks';
import ProviderStatementBalanceEmailTemplateFilters from './sections/ProviderStatementBalanceEmailTemplate.Filters';
import ProviderStatementBalanceEmailTemplateEdit from './sections/ProviderStatementBalanceEmailTemplate.Edit';
import ProviderStatementBalanceEmailTemplateDelete from './sections/ProviderStatementBalanceEmailTemplate.Delete';
import ProviderStatementBalanceEmailTemplateList from './sections/ProviderStatementBalanceEmailTemplate.List';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const providerStatementBalanceEmailTemplateIndexRoute =
  managementHomeRoute + '/providerStatementBalanceEmailTemplate/:action?/:id?';
export default function ProviderStatementBalanceEmailTemplateIndex() {
  const { lang } = getLocales();
  const emailTemplateHook = useProviderStatementBalanceEmailTemplate();

  if (!emailTemplateHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={emailTemplateHook}
        render={({ listApi, views, pageRouter, permissions }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.emailTemplates} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <ProviderStatementBalanceEmailTemplateFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_EMAILTEMPLATE}
                    data={{ action: ProviderStatementBalanceEmailTemplateAction.EDIT }}
                  />
                </Box>
              </>
            }
            subHeader={!isMobile && <ProviderStatementBalanceEmailTemplateFilters />}
            render={
              <>
                {views.edit && <ProviderStatementBalanceEmailTemplateEdit />}
                {views.delete && <ProviderStatementBalanceEmailTemplateDelete />}
                <ProviderStatementBalanceEmailTemplateList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
